export function BrowserEdgeIcon() {
  return (
    <svg
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Edge</title>
      <g id="browser-edge-colour" clipPath="url(#clip0_0_850)">
        <path
          id="Vector"
          d="M14.4437 11.9063C14.2292 12.0178 14.0079 12.1159 13.7813 12.2C13.0635 12.4672 12.3034 12.6027 11.5375 12.6C8.58125 12.6 6.00625 10.5688 6.00625 7.95625C6.01009 7.60643 6.10708 7.26394 6.28724 6.96405C6.46739 6.66415 6.72421 6.41768 7.03125 6.25C4.35625 6.3625 3.66875 9.15 3.66875 10.7813C3.66875 15.4063 7.925 15.8688 8.84375 15.8688C9.3375 15.8688 10.0813 15.725 10.5313 15.5813L10.6125 15.5563C12.3346 14.9611 13.8027 13.7972 14.775 12.2563C14.8033 12.2094 14.8154 12.1546 14.8095 12.1003C14.8037 12.0459 14.7801 11.9949 14.7425 11.9552C14.7049 11.9155 14.6554 11.8892 14.6014 11.8804C14.5474 11.8715 14.4921 11.8806 14.4437 11.9063Z"
          fill="url(#paint0_linear_0_850)"
        />
        <path
          id="Vector_2"
          opacity="0.35"
          d="M14.4437 11.9063C14.2292 12.0178 14.0079 12.1159 13.7813 12.2C13.0635 12.4672 12.3034 12.6027 11.5375 12.6C8.58125 12.6 6.00625 10.5688 6.00625 7.95625C6.01009 7.60643 6.10708 7.26394 6.28724 6.96405C6.46739 6.66415 6.72421 6.41768 7.03125 6.25C4.35625 6.3625 3.66875 9.15 3.66875 10.7813C3.66875 15.4063 7.925 15.8688 8.84375 15.8688C9.3375 15.8688 10.0813 15.725 10.5313 15.5813L10.6125 15.5563C12.3346 14.9611 13.8027 13.7972 14.775 12.2563C14.8033 12.2094 14.8154 12.1546 14.8095 12.1003C14.8037 12.0459 14.7801 11.9949 14.7425 11.9552C14.7049 11.9155 14.6554 11.8892 14.6014 11.8804C14.5474 11.8715 14.4921 11.8806 14.4437 11.9063Z"
          fill="url(#paint1_radial_0_850)"
        />
        <path
          id="Vector_3"
          d="M6.60625 15.0813C6.04993 14.7357 5.5677 14.2832 5.1875 13.75C4.75334 13.1557 4.45448 12.4737 4.31191 11.7517C4.16933 11.0296 4.1865 10.2852 4.36219 9.57048C4.53788 8.8558 4.86785 8.18823 5.32893 7.61461C5.79002 7.04099 6.37105 6.57522 7.03125 6.25C7.23125 6.15625 7.5625 5.99375 8.00625 6C8.3185 6.00242 8.62597 6.07701 8.90462 6.21796C9.18326 6.35891 9.42553 6.56239 9.6125 6.8125C9.86397 7.15068 10.0018 7.55984 10.0062 7.98125C10.0062 7.96875 11.5375 3.00625 5.00625 3.00625C2.2625 3.00625 0.00625 5.60625 0.00625 7.89375C-0.00466342 9.1021 0.253674 10.2977 0.7625 11.3938C1.59579 13.1681 3.05158 14.5748 4.85352 15.3467C6.65546 16.1187 8.6781 16.2021 10.5375 15.5813C9.88607 15.787 9.19773 15.8488 8.52006 15.7625C7.84239 15.6762 7.19154 15.4437 6.6125 15.0813H6.60625Z"
          fill="url(#paint2_linear_0_850)"
        />
        <path
          id="Vector_4"
          opacity="0.41"
          d="M6.60625 15.0813C6.04993 14.7357 5.5677 14.2832 5.1875 13.75C4.75334 13.1557 4.45448 12.4737 4.31191 11.7517C4.16933 11.0296 4.1865 10.2852 4.36219 9.57048C4.53788 8.8558 4.86785 8.18823 5.32893 7.61461C5.79002 7.04099 6.37105 6.57522 7.03125 6.25C7.23125 6.15625 7.5625 5.99375 8.00625 6C8.3185 6.00242 8.62597 6.07701 8.90462 6.21796C9.18326 6.35891 9.42553 6.56239 9.6125 6.8125C9.86397 7.15068 10.0018 7.55984 10.0062 7.98125C10.0062 7.96875 11.5375 3.00625 5.00625 3.00625C2.2625 3.00625 0.00625 5.60625 0.00625 7.89375C-0.00466342 9.1021 0.253674 10.2977 0.7625 11.3938C1.59579 13.1681 3.05158 14.5748 4.85352 15.3467C6.65546 16.1187 8.6781 16.2021 10.5375 15.5813C9.88607 15.787 9.19773 15.8488 8.52006 15.7625C7.84239 15.6762 7.19154 15.4437 6.6125 15.0813H6.60625Z"
          fill="url(#paint3_radial_0_850)"
        />
        <path
          id="Vector_5"
          d="M9.525 9.3C9.46875 9.3625 9.3125 9.45625 9.3125 9.65C9.3125 9.8125 9.41875 9.975 9.6125 10.1062C10.5062 10.7312 12.2 10.6437 12.2062 10.6437C12.8725 10.6433 13.5265 10.4642 14.1 10.125C14.6774 9.78729 15.1565 9.30452 15.4897 8.72458C15.823 8.14463 15.9989 7.48764 16 6.81875C16.0187 5.41875 15.5 4.4875 15.2937 4.075C13.9625 1.4875 11.1062 -4.37672e-07 8 -4.37672e-07C5.89762 -0.000208325 3.87965 0.827186 2.38255 2.30323C0.885453 3.77928 0.0295647 5.78532 -9.53674e-08 7.8875C0.0312499 5.60625 2.3 3.7625 5 3.7625C5.21875 3.7625 6.46875 3.78125 7.625 4.3875C8.43732 4.79116 9.11001 5.42902 9.55625 6.21875C9.9375 6.88125 10.0062 7.725 10.0062 8.0625C10.0062 8.4 9.8375 8.89375 9.51875 9.30625L9.525 9.3Z"
          fill="url(#paint4_radial_0_850)"
        />
        <path
          id="Vector_6"
          d="M9.525 9.3C9.46875 9.3625 9.3125 9.45625 9.3125 9.65C9.3125 9.8125 9.41875 9.975 9.6125 10.1062C10.5062 10.7312 12.2 10.6437 12.2062 10.6437C12.8725 10.6433 13.5265 10.4642 14.1 10.125C14.6774 9.78729 15.1565 9.30452 15.4897 8.72458C15.823 8.14463 15.9989 7.48764 16 6.81875C16.0187 5.41875 15.5 4.4875 15.2937 4.075C13.9625 1.4875 11.1062 -4.37672e-07 8 -4.37672e-07C5.89762 -0.000208325 3.87965 0.827186 2.38255 2.30323C0.885453 3.77928 0.0295647 5.78532 -9.53674e-08 7.8875C0.0312499 5.60625 2.3 3.7625 5 3.7625C5.21875 3.7625 6.46875 3.78125 7.625 4.3875C8.43732 4.79116 9.11001 5.42902 9.55625 6.21875C9.9375 6.88125 10.0062 7.725 10.0062 8.0625C10.0062 8.4 9.8375 8.89375 9.51875 9.30625L9.525 9.3Z"
          fill="url(#paint5_radial_0_850)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_850"
          x1="3.66875"
          y1="11.0625"
          x2="14.8188"
          y2="11.0625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C59A4" />
          <stop offset="1" stopColor="#114A8B" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_0_850"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.825 11.1466) scale(5.9625 5.66438)"
        >
          <stop offset="0.7" stopOpacity="0" />
          <stop offset="0.9" stopOpacity="0.5" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_0_850"
          x1="9.54375"
          y1="6.225"
          x2="2.5875"
          y2="13.8062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B9DE2" />
          <stop offset="0.2" stopColor="#1595DF" />
          <stop offset="0.7" stopColor="#0680D7" />
          <stop offset="1" stopColor="#0078D4" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_0_850"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.3425 -8.8605 -7.16 -1.074 4.40969 12.4336)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.8" stopOpacity="0" />
          <stop offset="0.9" stopOpacity="0.5" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_0_850"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-0.506 12.65 26.9445 1.012 1.61812 2.95725)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35C1F1" />
          <stop offset="0.1" stopColor="#34C1ED" />
          <stop offset="0.2" stopColor="#2FC2DF" />
          <stop offset="0.3" stopColor="#2BC3D2" />
          <stop offset="0.7" stopColor="#36C752" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_0_850"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.70275 5.838 4.74338 -1.39869 15.0038 4.83125)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66EB6E" />
          <stop offset="1" stopColor="#66EB6E" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_0_850">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
